module.exports = __webpack_public_path__ + "img/ICHRA - Future of Health Benefits Infographic.d2d2b478.png";